// const ApiUrl = "http://127.0.0.1:9096/CPIA-BACKEND/"//接口根目录
const ApiUrl = "https://www.yaqiu.online/CPIA-BACKEND/"//接口根目录
// const ApiUrl = "/CPIA-BACKEND/"//接口根目录
const ApiRootUrl = ApiUrl + "robot/"
const resourceUrl = ApiUrl + "static/"

// 路由管理
export default {
    carouselUrl: resourceUrl + "carousel/",//轮播图资源根目录
    coverUrl: resourceUrl + "cover/",//案例卡片资源根目录
    modelUrl: resourceUrl + "model/",//模型资源根目录
    simulatorUrl: resourceUrl + "simulator/",//仿真器素材资源根目录
    getAllBlocks: ApiRootUrl + "getAllBlocks",
    getQuickStartBlocks: ApiRootUrl + "getQuickStartBlocks",
    getStudyCaseBlocks: ApiRootUrl + "getStudyCaseBlocks",
    saveBlock: ApiRootUrl + "saveBlock",
    addBlock: ApiRootUrl + "addBlock",
    deleteBlock: ApiRootUrl + "deleteBlock",
    addNewProjectType: ApiRootUrl + "addNewProjectType",
    getProjectTypes: ApiRootUrl + "getProjectTypes",
    editProjectType: ApiRootUrl + "editProjectType",
    addProjectType: ApiRootUrl + "addProjectType",
    deleteProjectType: ApiRootUrl + "deleteProjectType",

    plantingCropInfoList: ApiUrl + "plantingCropInfo/list",
    plantingCropInfoDel: ApiUrl + "plantingCropInfo/del",
    plantingCropInfoUpdate: ApiUrl + "plantingCropInfo/update",
    plantingCropInfoAdd: ApiUrl + "plantingCropInfo/add",

    plantingPlanTaskList: ApiRootUrl + "plantingPlanTask/list",
    plantingPlanTaskDel: ApiRootUrl + "plantingPlanTask/del",
    plantingPlanTaskUpdate: ApiRootUrl + "plantingPlanTask/update",
    plantingPlanTaskAdd: ApiRootUrl + "plantingPlanTask/add",

    plantingSchemeList: ApiRootUrl + "plantingScheme/list",
    plantingSchemeDel: ApiRootUrl + "plantingScheme/del",
    plantingSchemeUpdate: ApiRootUrl + "plantingScheme/update",
    plantingSchemeAdd: ApiRootUrl + "plantingScheme/add",

    courseList: ApiUrl + "/course/table",
    sensorInfo: ApiUrl + "/sensor/allSensorDataByGreenhouseId",
    aiAsk: ApiUrl + "/question/testWenxin",

    taskJobs: ApiUrl + "/basegrow/taskJobs",
    taskInfo: ApiUrl + "/plant/listTask",
    addTask: ApiUrl + "/basegrow/addDeviceTask",
    recommendCourse:"http://127.0.0.1:8091/student/index/page/recommendCourse",
    courseVideoList:"http://127.0.0.1:8091/student/course/courseVideoList",
    getCourseById:ApiUrl + "course/getCourseById",
    // courseRecordList: "http://127.0.0.1:8091/student/course/courseRecordList",
    courseRecordList: ApiUrl + "user/courseRecordList",
    addCourseRecord: ApiUrl + "user/addCourseRecord",
    getVideoPlayHis: ApiUrl + "user/videoRecord",


    login: ApiUrl + "/user/login",
    getGreenhouseByUser: ApiUrl + "greenhouse/getGreenhouse",
    updateGreenhouse:ApiUrl + "greenhouse/updateGreenhouse",

    getCodingRecords: ApiRootUrl + "getCodingRecords",
    addBlocksAndRecord: ApiRootUrl + "addBlocksAndRecord",
    updateBlocksAndRecord: ApiRootUrl + "updateBlocksAndRecord",
    getBlocksByParam: ApiRootUrl + "getBlocksByParam",
    //控制执行机构开关
    difActuatorControl:ApiUrl + "/actuator/difActuatorControl",

    allCrop: ApiUrl + "basCropInfo/selectAll",

    getVideosByCourseId: ApiUrl + "course/getVideosByCourseId",
    getCourseByClassfication: ApiUrl + "course/getCourseByClassfication",

    updateTaskStatus: ApiUrl + "/basegrow/updateTaskStatus",
    deviceTaskInfo: ApiUrl + "/basegrow/deviceTaskInfo",
};
